import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid p-0" }
const _hoisted_2 = { class: "row mb-2 mb-xl-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-auto d-none d-sm-block" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Документы")
], -1)
const _hoisted_4 = { class: "col-auto ms-auto text-end mt-n1 d-flex" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-12" }
const _hoisted_7 = { class: "card border" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Фильтр")
], -1)
const _hoisted_9 = { class: "card-body pt-0 loader" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12 col-lg-2" }
const _hoisted_12 = { class: "col-12 col-lg-2" }
const _hoisted_13 = { class: "col-12 col-lg-2" }
const _hoisted_14 = { class: "col-12 col-lg-2" }
const _hoisted_15 = { class: "col-12 col-lg-2" }
const _hoisted_16 = { class: "overflow-hidden" }
const _hoisted_17 = {
  class: "bg-white position-relative overflow-auto mw-100 pb-5",
  style: {"max-height":"670px"}
}
const _hoisted_18 = { class: "table table-bordered" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("thead", { class: "sticky-top bg-white" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "position-relative border-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "# п/п"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Тип документа"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Подтип документа"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Дата"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Наименование"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Краткое содержание"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Контрагент"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Техника"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Тэги"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Автор"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Обновлено"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" })
  ])
], -1)
const _hoisted_20 = { class: "py-2 px-3" }
const _hoisted_21 = { class: "py-2 px-3" }
const _hoisted_22 = { class: "py-2 px-3" }
const _hoisted_23 = { class: "py-2 px-3" }
const _hoisted_24 = { class: "py-2 px-3" }
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "py-2 px-3" }
const _hoisted_27 = { class: "py-2 px-3" }
const _hoisted_28 = { class: "py-2 px-3" }
const _hoisted_29 = { class: "py-2 px-3" }
const _hoisted_30 = { class: "py-2 px-3" }
const _hoisted_31 = { class: "py-2 px-3" }
const _hoisted_32 = { class: "py-2 px-3" }
const _hoisted_33 = { class: "btn btn-sm d-flex justify-content-center align-items-center" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", {
  class: "py-2 px-3 text-center",
  colspan: "5"
}, "Документы отсутствуют", -1)
const _hoisted_36 = [
  _hoisted_35
]

import { reactive, onMounted, watch, computed } from 'vue';
import '@hennge/vue3-pagination/dist/vue3-pagination.css';
import api from '@/api';
import { userStore } from '@/store/userStore';
import { useModal } from '@/composables/useModal';
import { IDocument, IDocumentType, IDocumentSubtype } from '@/@types/IDocument';
import { ISupplier } from '@/@types/ISupplier';
import { ILocomotive } from '@/@types/ILocomotive';
import formatDate from '@/utils/formatDate';

type stateType = {
    documents: IDocument[];
    documentTypes: IDocumentType[];
    documentSubTypes: IDocumentSubtype[];
    filteredDocumentSubTypes: IDocumentSubtype[];
    contractors: ISupplier[];
    locomotives: ILocomotive[];
    search: string;
    selectedDocumentType: number;
    selectedDocumentSubType: number;
    locomotiveId: number;
    contractorId: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentComponent',
  setup(__props) {

const backendUrl = process.env.VUE_APP_API_URL;

const { user } = userStore();
const state: stateType = reactive({
    documents: [],
    documentTypes: [],
    documentSubTypes: [],
    filteredDocumentSubTypes: [],
    contractors: [],
    locomotives: [],
    search: '',
    selectedDocumentType: 0,
    selectedDocumentSubType: 0,
    locomotiveId: 0,
    contractorId: 0,
});

async function getDocuments(params = {}) {
    return api.document.getMany(params).then(({ data }) => {
        state.documents = data;
    });
}

async function getDocumentTypes() {
    return api.document.getTypes().then(({ data }) => {
        state.documentTypes = data;
    });
}

async function getDocumentSubTypes() {
    return api.document.getSubTypes().then(({ data }) => {
        state.documentSubTypes = data;
        state.filteredDocumentSubTypes = data;
    });
}

async function getContractors() {
    return api.supplier.get().then((r) => {
        state.contractors = r.data;
    });
}

async function getLocomotives() {
    return api.locomotives
        .getAll()
        .then((data) => {
            state.locomotives = data;
        })
        .catch(console.error);
}

const filteredLocomotives = computed(() => {
    if (!state.contractorId) {
        return [];
    }

    const contractor = state.contractors.find((c) => c.id === state.contractorId);

    if (!contractor) {
        return [];
    }

    return state.locomotives.filter(
        (locomotive) => locomotive.contractorId === Number(contractor.rollingStockOwner?.id),
    );
});

onMounted(() => {
    getDocuments();
    getDocumentTypes();
    getDocumentSubTypes();
    getContractors();
    getLocomotives();
});

function handleCreateDocument() {
    useModal('document_modal').open().then(getDocuments).catch(console.error);
}

function handleSelectDocumentType(documentType: IDocumentType) {
    if (state.selectedDocumentType === documentType.id) {
        state.selectedDocumentType = 0;
        state.filteredDocumentSubTypes = state.documentSubTypes;
    } else {
        state.selectedDocumentType = documentType.id;
        state.selectedDocumentSubType = 0;
        state.filteredDocumentSubTypes = state.documentSubTypes.filter(
            (subType) => subType.documentTypeId === documentType.id,
        );
    }
}

function handleSelectDocumentSubType(documentSubType: IDocumentSubtype) {
    state.selectedDocumentSubType = state.selectedDocumentSubType === documentSubType.id ? 0 : documentSubType.id;
}

function handleSupplierSelect(supplier: ISupplier) {
    state.locomotiveId = 0;
    state.contractorId = state.contractorId === supplier.id ? 0 : supplier.id;
}

function handleLocomotiveSelect(locomotive: ILocomotive) {
    state.locomotiveId = state.locomotiveId === locomotive.id ? 0 : locomotive.id;
}

function handleEditDocument(document: IDocument) {
    useModal('edit_document_modal')
        .open({
            document,
            documentNames: state.documents.reduce(
                (acc, d) => (d.id === document.id ? acc : [...acc, d.fileName]),
                [] as string[],
            ),
        })
        .then(getDocuments)
        .catch(console.error);
}

function handledeleteSummary(id: number) {
    useModal('confirm_modal')
        .open({
            question: 'Подтвердите удаление документа',
            ok: 'Да',
            cancel: 'Нет',
        })
        .then((r: any) => api.document.delete(id))
        .then(getDocuments);
}

watch(
    () => [
        state.search,
        state.selectedDocumentType,
        state.selectedDocumentSubType,
        state.locomotiveId,
        state.contractorId,
    ],
    () =>
        getDocuments({
            ...(!!state.selectedDocumentType && { selectedDocumentType: state.selectedDocumentType }),
            ...(!!state.selectedDocumentSubType && { selectedDocumentSubType: state.selectedDocumentSubType }),
            ...(!!state.locomotiveId && { locotomiveId: state.locomotiveId }),
            ...(!!state.contractorId && { contractorId: state.contractorId }),
            ...(!!state.search && { search: state.search }),
        }),
);

return (_ctx: any,_cache: any) => {
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_dropdown_ui = _resolveComponent("dropdown-ui")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_button_ui, {
            "button-class": "btn-primary ms-3 btn-sm",
            onClick: handleCreateDocument
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Создать ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("form", null, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_form_group_ui, { label: "Тип" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_select_ui, {
                          "item-key": "name",
                          options: [{ id: 0, name: 'Не выбрано' }, ...state.documentTypes],
                          placeholder: "Тип",
                          searchable: true,
                          values: [state.selectedDocumentType],
                          onOnSelected: handleSelectDocumentType
                        }, null, 8, ["options", "values"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_form_group_ui, { label: "Подтип" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_select_ui, {
                          "item-key": "name",
                          options: [
                                                { id: 0, name: 'Не выбрано' },
                                                ...state.filteredDocumentSubTypes,
                                            ],
                          placeholder: "Подтип",
                          searchable: true,
                          values: [state.selectedDocumentSubType],
                          onOnSelected: handleSelectDocumentSubType
                        }, null, 8, ["options", "values"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_form_group_ui, { label: "Наименование" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_input_ui, {
                          modelValue: state.search,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.search) = $event)),
                          placeholder: "Название",
                          searchable: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_form_group_ui, { label: "Контрагент" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_select_ui, {
                          "item-key": "name",
                          options: state.contractors,
                          placeholder: "Контрагент",
                          searchable: true,
                          values: [state.contractorId],
                          onOnSelected: handleSupplierSelect
                        }, null, 8, ["options", "values"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_form_group_ui, { label: "Техника" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_select_ui, {
                          "item-key": "name",
                          options: filteredLocomotives.value,
                          placeholder: "Техника",
                          searchable: true,
                          values: [state.locomotiveId],
                          onOnSelected: handleLocomotiveSelect
                        }, null, 8, ["options", "values"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("table", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("tbody", null, [
              (state.documents.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.documents, (document, idx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: document.id
                    }, [
                      _createElementVNode("td", _hoisted_20, _toDisplayString(idx + 1), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(document?.subType?.documentType?.name), 1),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(document?.subType?.name), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(formatDate)(document.documentedAt)), 1),
                      _createElementVNode("td", _hoisted_24, [
                        _createElementVNode("a", {
                          class: "text-primary",
                          href: _unref(backendUrl) + document.path,
                          target: "_blank"
                        }, _toDisplayString(document.fileName), 9, _hoisted_25)
                      ]),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(document?.comment || '-'), 1),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(document.contractor?.name || '-'), 1),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(document.locomotive?.name || '-'), 1),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(document.tags.length ? document.tags.join(', ') : '-'), 1),
                      _createElementVNode("td", _hoisted_30, _toDisplayString(document.author?.fullName || document.author?.login), 1),
                      _createElementVNode("td", _hoisted_31, _toDisplayString(_unref(formatDate)(document.updatedAt, 'DD.MM.YYYY HH:mm')), 1),
                      _createElementVNode("td", _hoisted_32, [
                        (_unref(user).id === document.authorId)
                          ? (_openBlock(), _createBlock(_component_dropdown_ui, { key: 0 }, {
                              button: _withCtx(() => [
                                _createElementVNode("button", _hoisted_33, [
                                  _createVNode(_component_vue_feather, {
                                    size: "14px",
                                    type: "more-vertical"
                                  })
                                ])
                              ]),
                              list: _withCtx(() => [
                                _createVNode(_component_button_ui, {
                                  class: "dropdown-item cursor-pointer",
                                  onClick: ($event: any) => (handleEditDocument(document))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Редактировать ")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_button_ui, {
                                  class: "dropdown-item cursor-pointer",
                                  onClick: ($event: any) => (handledeleteSummary(document.id))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Удалить ")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("tr", _hoisted_34, _hoisted_36))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})